class InspirationPopup extends HTMLElement {
  constructor() {
    super();

    this.openTrigger = this.querySelector('[data-open]');
    this.closeTrigger = this.querySelector('[data-close]');
    this.popup = this.querySelector('.inspiration-item--popup');

    if (this.openTrigger) {
      this.openTrigger.addEventListener('click', this.toggleHandler.bind(this));
    }

    if (this.closeTrigger) {
      this.closeTrigger.addEventListener('click', this.toggleHandler.bind(this));
    }

    if (this.popup) {
      this.popup.addEventListener('click', this.popupCloseHandler.bind(this));
    }
  }

  toggleHandler(e) {
    this.classList.toggle('open');
  }
  
  popupCloseHandler(e) {
    if (!this.querySelector('.inspiration-item--popup-inner:hover')) {
      this.classList.toggle('open');
    }
  }
}

customElements.define('inspiration-popup', InspirationPopup);